import { useApiQuery } from 'theSource/utils';
import { PlansResponseDto } from './types';
import { GET_BENEFIT_PLANS_QUERY_KEY } from './utils';

export interface UseBenefitPlansQueryProps {
  orgBenefitId?: number;
  enrollmentContextType?: string;
  dependentIds?: number[];
  enabled: boolean;
  lumosApiHost?: string;
  keepPreviousData?: boolean;
  key?: string;
  includeContentDetails?: boolean;
  includeEligibleDependentsData?: boolean;
}

export const useBenefitPlansQuery = ({
  orgBenefitId,
  enrollmentContextType,
  dependentIds,
  enabled,
  lumosApiHost,
  includeEligibleDependentsData,
  key = GET_BENEFIT_PLANS_QUERY_KEY,
  keepPreviousData = false,
  includeContentDetails = true,
}: UseBenefitPlansQueryProps) => {
  const {
    data: plansData,
    isLoading: isLoadingPlans,
    isFetching: isFetchingPlans,
  } = useApiQuery<PlansResponseDto>({
    queryKey: [
      key + '-' + orgBenefitId,
      dependentIds ? dependentIds.toString() : '',
    ],
    config: {
      baseURL: `${lumosApiHost}/v2/self_service`,
    },
    endpoint: '/plans',
    enabled: enabled,
    params: {
      org_benefit_id: orgBenefitId,
      enrollment_context_type: enrollmentContextType,
      dependent_ids: dependentIds,
      include_content_details: includeContentDetails,
      include_eligible_dependents_data: includeEligibleDependentsData || false,
    },
    keepPreviousData: keepPreviousData,
  });

  return {
    plansData,
    isLoadingPlans,
    isFetchingPlans,
  };
};
